module.exports = __webpack_public_path__ + "img/empty_state_light.61310cea.png";